import React, {useState} from "react";
import logo from "../../assets/img/icon_logo.svg";
import {EventBus} from "../../util/EventBus";
import {FormattedMessage} from "react-intl";
import {clearStorageItems, onUseAppInsteadOfWeb} from "../../util/common.js";
import {PATH} from "../../routes/routes.js";
import {useNavigate} from "react-router";

function Modal() {
    const navigateTo = useNavigate();

    const visible = "visible";
    const hidden = "hidden";
    const [currentStyle, setCurrentStyle] = useState(hidden);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [message2, setMessage2] = useState("");
    const [hasLogo, setHasLogo] = useState(false);
    const [hasDismissBtn, setHasDismissBtn] = useState(false);
    const [dismissMsg, setDismissMsg] = useState("");
    const [hasActionBtn, setHasActionBtn] = useState(false);
    const [actionMethod, setActionMethod] = useState(null);
    const [isInformationalModal, setIsInformationalModal] = useState(false);


    const openModal = (hasLogo, title, message, message2, hasDismissBtn, dismissMsgText, isInformationalModal, hasActionBtn) => {
        setHasLogo(hasLogo);
        setTitle(title)
        setMessage(message);
        setMessage2(message2);
        setHasDismissBtn(hasDismissBtn);
        setDismissMsg(dismissMsgText);
        setCurrentStyle(visible);
        setIsInformationalModal(isInformationalModal);
        setHasActionBtn(hasActionBtn);
    }
    const closeModal = () => {
        setCurrentStyle(hidden);
    }

    React.useEffect(() => {
        EventBus.on("accessingOnlyInAppCampaign", (data) => {
            setActionMethod("accessingOnlyInAppCampaign")
            openModal(true,null, <FormattedMessage id="Modal.accessingOnlyInAppCampaign"/>,null, true, <FormattedMessage id="Modal.dismissMsg"/>, false, true, false);
        });

        EventBus.on("accessingOnlyInAppProduct", (data) => {
            setActionMethod("accessingOnlyInAppProduct");
            openModal(true,null,<FormattedMessage id="Modal.accessingOnlyInAppProduct"/>, null, true, <FormattedMessage id="Modal.dismissMsg"/>, false, true, false);
        });

        EventBus.on("accessingOnlyLoggedUsersProduct", (data) => {
            setActionMethod("accessingOnlyLoggedUsersProduct");
            openModal(true,null,<FormattedMessage id="Modal.accessingOnlyLoggedUsersProduct"/>, null, true, <FormattedMessage id="Modal.dismissMsg"/>, false, true, false);
        });

        EventBus.on("accessingOnlyLoggedUsersFeature", (data) => {
            setActionMethod("accessingOnlyLoggedUsersFeature");
            openModal(true,null,<FormattedMessage id="Modal.accessingOnlyLoggedUsersFeature"/>, null, true, <FormattedMessage id="Modal.dismissMsg"/>, false, true, false);
        });

        EventBus.on("waiterClosedTheOrder", (data) => {
            setActionMethod("waiterClosedTheOrder");
            openModal(false,<FormattedMessage id="Oooops"/>,<FormattedMessage id="YourOrderWasClosed"/>, <FormattedMessage id="WouldYouLikeToStartAnewOrder"/>, true, <FormattedMessage id="Ok"/>, false, true, false);
        });

        EventBus.on("shopIsClosed", (data) => {
            openModal(false,null,<FormattedMessage id="ShopIsClosed"/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });

        EventBus.on("multiOrdersSetToFalse", (data) => {
            openModal(false,null,<FormattedMessage id="MultiOrdersValidation"/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });

        EventBus.on("QRwasNotScaned", (data) => {
            openModal(false,null,<FormattedMessage id="ScanTheQrToContinue"/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });
        EventBus.on("closeOrderFirst", (data) => {
            openModal(false,null,<FormattedMessage id="CloseYourOrderFirst"/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });

        EventBus.on("minExtrasError", (data) => {
            // TODO: change message here and use data for a number about min/max extras
            openModal(false,null,<FormattedMessage id="SelectMinExtras" values={{min: data}}/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });

        EventBus.on("maxExtrasError", (data) => {
            // TODO: change message here and use data for a number about min/max extras
            openModal(false,null,<FormattedMessage id="SelectMaxExtras" values={{max: data}}/>, null, true, <FormattedMessage id="OkGotIt"/>, true, false, false);
        });


        // Specify how to clean up after this effect:
        return function cleanup() {
            EventBus.remove("accessingOnlyInAppCampaign");
            EventBus.remove("accessingOnlyInAppProduct");
            EventBus.remove("accessingOnlyLoggedUsersProduct");
            EventBus.remove("accessingOnlyLoggedUsersFeature");
            EventBus.remove("waiterClosedTheOrder");
            EventBus.remove("shopIsClosed");
            EventBus.remove("multiOrdersSetToFalse");
            EventBus.remove("QRwasNotScaned");
            EventBus.remove("closeOrderFirst");
            EventBus.remove("minExtrasError");
            EventBus.remove("maxExtrasError");
        };
    },[]);

    const onActionButton = () => {
        if (actionMethod === "accessingOnlyInAppCampaign") {
            onUseAppInsteadOfWeb();
        } else if (actionMethod === "accessingOnlyInAppProduct") {
            onUseAppInsteadOfWeb();
        } else if (actionMethod === "accessingOnlyLoggedUsersProduct") {
            navigateTo({
                pathname: PATH.LOGIN,
                search: "?redirect=back"
            });

        } else if (actionMethod === "accessingOnlyLoggedUsersFeature") {
            navigateTo({
                pathname: PATH.LOGIN,
                search: "?redirect=back"
            });


        } else if (actionMethod === "waiterClosedTheOrder") {
            clearStorageItems();
            navigateTo(PATH.ALL_PRODUCTS);

        }

    }
    return (
        <>
        <div className={currentStyle+" modal-overlay "} data-qa="modal-close-overlay" onClick={(e)=> closeModal()}>   </div>
            <div data-qa="modal" className="modal">
                {title!=null?

                    <div className="row">
                        <div className="modal-title">{title}</div>
                    </div>
                : null
                }
                <div className="row">
                    <p className="modal-text">{message}</p>
                </div>
                {message2?
                    <div className="row">
                        <p className="modal-text">{message2}</p>
                    </div>
                    : null
                }

                {
                    isInformationalModal?
                            <a className="btn btn-default mt-20" target="_blank" onClick={()=>closeModal()}><FormattedMessage id="OkGotIt"/></a>
                            :
                            <>
                                {hasLogo?
                                    <div className="row">
                                        <img alt="logo icon" src={logo}/>
                                    </div>
                                    : null
                                }

                                <div className={actionMethod === "waiterClosedTheOrder" ? "row order-closed-row" : ""}>
                                {hasActionBtn?
                                        <div className="row">
                                            {actionMethod === "waiterClosedTheOrder" ?
                                                <a className="btn start-order-btn" onClick={() => onActionButton()}>
                                                    <FormattedMessage id="StartOrder"/>
                                                </a>
                                                :
                                                actionMethod === "accessingOnlyLoggedUsersProduct" || actionMethod === "accessingOnlyLoggedUsersFeature"?
                                                    <a target="_blank" onClick={() => onActionButton()} className="btn btn-default" data-qa="modal-go-to-login-page-btn">
                                                        <FormattedMessage id="LogIn"/>
                                                    </a>
                                                    :


                                                <a target="_blank" onClick={() => onActionButton()} className="btn btn-default">
                                                   <FormattedMessage id="Modal.buttonText"/>
                                                </a>
                                            }
                                        </div>
                                        : null
                                }
                                {hasDismissBtn?
                                    <div className="row">
                                        {actionMethod === "waiterClosedTheOrder" ?
                                            <a onClick={()=>navigateTo(PATH.THANK_YOU)} className="dismiss-msg">{dismissMsg}</a>
                                            :<a data-qa="modal-close-btn" onClick={() => closeModal()} data-qa="modal-dismiss-btn" className="dismiss-msg">{dismissMsg}</a>
                                        }
                                    </div>
                                    : null
                                }
                                </div>

                            </>
                }
            </div>
        </>



    );

}



export default Modal;
